import type { Task } from '@medplum/fhirtypes'

/**
 * Subset of the Task intent and status values that are supported by the SDR task
 */

export const SUPPORTED_TASK_INTENT = {
  PROPOSAL: 'proposal', // the request has been created
  PLAN: 'plan', // the proposal is being discussed by the idt
  ORDER: 'order', // the proposal is being actioned
} satisfies Record<string, Task['intent']>

export const SUPPORTED_TASK_STATUS = {
  DRAFT: 'draft',
  REQUESTED: 'requested',
  RECEIVED: 'received',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  READY: 'ready',
  CANCELLED: 'cancelled',
  IN_PROGRESS: 'in-progress',
  ON_HOLD: 'on-hold',
  FAILED: 'failed',
  COMPLETED: 'completed',
} satisfies Record<string, Task['status']>
